import dayjs from 'dayjs';
import { getAmenityTypeKeys } from '../../../components/amenities/AmenityTypes';
import { serializeAmenityOverrides } from './amenitiesForm/amenityOverrideUtils';

const DEBUG = process.env.NODE_ENV !== 'production';

const cleanOverride = async (values, brewery) => {
  // Convert Day.js objects to strings before cloning (structuredClone doesn't handle Day.js objects)
  // This also prevents browser extensions from encountering non-serializable objects
  const valuesToClone = { ...values };
  
  // Check for Day.js objects in oobDate and convert before structuredClone
  if (valuesToClone.oobDate && dayjs.isDayjs(valuesToClone.oobDate)) {
    // Format as M/D/YYYY to match existing Firestore format (e.g., "1/1/2026")
    valuesToClone.oobDate = valuesToClone.oobDate.format('M/D/YYYY');
    if (DEBUG) {
      console.debug('[DEBUG cleanOverride] Converted Day.js oobDate to string');
    }
  }
  
  // Check for any other Day.js objects in the values (safety check)
  Object.keys(valuesToClone).forEach(key => {
    const value = valuesToClone[key];
    if (value && typeof value === 'object' && dayjs.isDayjs(value)) {
      if (DEBUG) {
        console.warn(`[DEBUG cleanOverride] Found unexpected Day.js object in key "${key}"`);
      }
    }
  });
  
  // Clone after Day.js conversion (all Day.js objects should be strings by now)
  const override = await structuredClone(valuesToClone);

  // delete oob indicator if it's not being changed
  if (brewery.isOob === false && override.isOob === false) {
    delete override.oobDate;
    delete override.isOob;
  }

  // if update Oob flag is false, delete the oobDate and isOob flag
  if (override.updateOob === false) {
    delete override.isOob;
    delete override.oobDate;
    delete override.updateOob;
  }

  if (override.updateAmenities === true) {
    const serializedAmenities = serializeAmenityOverrides(
      override.amenities,
      getAmenityTypeKeys(),
    );
    if (Object.keys(serializedAmenities).length > 0) {
      override.amenities = serializedAmenities;
    } else {
      delete override.amenities;
    }
  } else {
    delete override.amenities;
    delete override.updateAmenities;
  }

  if (override.updateSocials === false) {
    delete override.socials;
    delete override.updateSocials;
  }

  Object.entries(override).forEach(([key, value]) => {
    // delete empty or null values
    if (value === '' || value === null || value === undefined) {
      delete override[key];
    }

    // delete empty arrays
    if (
      value &&
      typeof value === 'object' &&
      value.length &&
      value.length === 0
    ) {
      delete override[key];
    }

    // delete empty objects
    if (
      value &&
      typeof value === 'object' &&
      Object.entries(value).length === 0
    ) {
      delete override[key];
    }
  });

  return override;
};

export default cleanOverride;
